import React from "react"
import { isBefore, parseISO } from "date-fns"
import Divider from "~/components/divider"
import { InputGroup, InputDate, Autocomplete } from "~/components/form"
import { FilterContainer, Row } from "~/views/report-event/styles"
import _ from "lodash"
import { formats } from "~/helper"

export default function FormFilter({ setFieldValue, values, onListEvents, onListSuppliers }) {
  return (
    <FilterContainer>
      <Autocomplete
        name="eventId"
        label="Evento"
        required={true}
        clearable={true}
        keyField="id"
        value={_.get(values, "event") || {}}
        valueFormat={(row) =>
          `${row.name} - ${formats.dateTimeZone(row.eventDate, 'dd/MM/yyyy HH:mm')}`
        }
        loadData={onListEvents}
        emptyText={"Pesquise um evento"}
        tipText={"Digite... "}
        loadingText={"Carregando..."}
        notFoundText={"Não encontrado"}
        onChange={(value) => {
          setFieldValue("eventId", _.get(value, "id"))
          setFieldValue("event", value)
        }}
      />

      <Autocomplete
        name="supplierId"
        label="Fornecedor"
        required={true}
        clearable={true}
        keyField="id"
        value={_.get(values, "supplier") || {}}
        valueFormat={(row) => `${row.identify} - ${row.name}`}
        loadData={onListSuppliers}
        emptyText={"Pesquise um colaborador"}
        tipText={"Digite... "}
        loadingText={"Carregando..."}
        notFoundText={"Não encontrado"}
        onChange={(value) => {
          setFieldValue("supplierId", _.get(value, "id"))
          setFieldValue("supplier", value)
        }}
      />

      <InputGroup type="text" name="personName" label="Nome do colaborador" />

      <InputGroup
        type="text"
        name="personIdentitify"
        label="CPF/Nº Registro do colaborador"
      />

      <Divider label="Data do evento" />

      <Row span={2}>
        <InputDate
          name="eventDateStart"
          label="De"
          onChange={(value) => {
            if (!isBefore(value, parseISO(values.eventDateEnd))) {
              setFieldValue("eventDateStart", values.eventDateEnd)
              setFieldValue("eventDateEnd", value)
            } else {
              setFieldValue("eventDateStart", value)
            }
          }}
        />

        <InputDate
          name="eventDateEnd"
          label="Até"
          onChange={(value) => {
            if (isBefore(value, parseISO(values.eventDateStart))) {
              setFieldValue("eventDateStart", value)
              setFieldValue("eventDateEnd", values.eventDateStart)
            } else {
              setFieldValue("eventDateEnd", value)
            }
          }}
        />
      </Row>
    </FilterContainer>
  )
}
